import { tz } from 'moment-timezone';
import {
    DateFilterDefinition,
    FilterDefinition,
    MultiSelectFilterDefinition,
    SingleSelectFilterDefinition
} from '@agyletime/vue-3-common/src/components/FilterBar/utils/definitions/BaseItem';
import { FilterBar } from '@agyletime/vue-3-common/src/typings/filter';
type MultiSelectValue = FilterBar.MultiSelectValue

export function setupFilterItems(
    eventTypes: MultiSelectValue[],
    eventLevels: MultiSelectValue[],
    eventServices: MultiSelectValue[],
    weekStart: 0 | 1 | 2 | 3 | 4 | 5 | 6 | undefined = 1
): FilterDefinition[] {
    const types: MultiSelectFilterDefinition = {
        type: 'multiSelect',
        key: 'eventTypes',
        label: 'Event Type',
        nameKey: 'name',
        valueKey: 'value',
        grouped: false,
        options: eventTypes
    };

    const services: MultiSelectFilterDefinition = {
        type: 'multiSelect',
        key: 'eventServices',
        label: 'Service',
        nameKey: 'name',
        valueKey: 'service',
        grouped: false,
        options: eventServices
    };

    const levels: MultiSelectFilterDefinition = {
        type: 'multiSelect',
        key: 'eventLevels',
        label: 'Event Level',
        nameKey: 'name',
        valueKey: 'eventLevel',
        grouped: false,
        options: eventLevels
    };

    const localTimezone = tz.guess();
    const timezone: SingleSelectFilterDefinition = {
        type: 'singleSelect',
        key: 'timezone',
        label: 'Timezone',
        pluralLabel: 'Timezone',
        nameKey: 'name',
        valueKey: 'value',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        options: tz.names().map((zone: any) => ({ name: zone, value: zone })),
        default: {
            name: localTimezone,
            value: localTimezone
        }
    };

    const startDate: DateFilterDefinition = {
        type: 'date',
        key: 'startDate',
        label: 'Event Date',
        weekStart: weekStart ?? 1,
        enableTimePicker: false
    };
    return [
        types, services, levels, timezone, startDate
    ];
}